export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isAndroid = () => /Android/i.test(navigator.userAgent)

export const isIOs = () => /iPad|iPhone|iPod/i.test(navigator.userAgent)
